import { SelectItemType } from 'types/common';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface REVISIONCONFIGTYPE {
  disable_split_sentence: boolean;
  disable_caret_spacing: boolean;
  disable_vx_spacing: boolean;
  enable_cleanup_whitespace: boolean;
  enable_sentence_check: boolean;
}

interface REVISIONCONFIGTYPESTORE {
  revisionConfig: REVISIONCONFIGTYPE;
  customDictionaryList: SelectItemType[];
  setRevisionConfig: (revisionConfig: REVISIONCONFIGTYPE) => void;
  setCustomDictionaryList: (list: SelectItemType[]) => void;
}

export const useRevisionConfig = create<REVISIONCONFIGTYPESTORE>()(
  persist(
    (set) => ({
      revisionConfig: {
        disable_split_sentence: true,
        disable_caret_spacing: true,
        disable_vx_spacing: true,
        enable_cleanup_whitespace: true,
        enable_sentence_check: false
      },
      customDictionaryList: [],
      setRevisionConfig: (revisionConfig) => set({ revisionConfig }),
      setCustomDictionaryList: (list) => set({ customDictionaryList: list })
    }),
    {
      name: 'revision-config-storage', // localStorage key
      partialize: (state) => ({
        revisionConfig: state.revisionConfig,
        customDictionaryList: state.customDictionaryList
      })
    }
  )
);
